// extracted by mini-css-extract-plugin
export default {"container":"styles_container__efdiJ","loader":"styles_loader__A5QEy"};